import * as Sentry from '@sentry/react';

import localforage from 'localforage';

// Persist to IndexedDB (localforage) instead of localStorage: base64 photos and
// signatures blow past the ~5MB localStorage quota, whose overflow is swallowed and
// silently drops the whole offline set on reload. IndexedDB raises the ceiling to
// hundreds of MB. getItem/getAllKeys fall back to the legacy localStorage engine
// once, so a technician upgrading with unsynced offline data is migrated forward and
// not wiped. A failed write is reported (not swallowed) so quota trouble is visible.
localforage.config({ name: 'yuman', storeName: 'offline_state' })

export const persistStorage = {
  getAllKeys(callback) {
    localforage.keys()
      .then(keys => callback(null, Array.from(new Set([...keys, ...Object.keys(window.localStorage)]))))
      .catch(err => callback(err))
  },
  getItem(key, callback) {
    localforage.getItem(key)
      .then(value => {
        if (value != null) return callback(null, value)
        const legacy = window.localStorage.getItem(key)
        if (legacy != null) localforage.setItem(key, legacy).catch(() => {})
        return callback(null, legacy == null ? undefined : legacy)
      })
      .catch(err => callback(err))
  },
  setItem(key, value, callback) {
    localforage.setItem(key, value)
      .then(stored => callback && callback(null, stored))
      .catch(err => {
        Sentry.captureException(err, { extra: { persistKey: key } })
        callback && callback(err)
      })
  },
  removeItem(key, callback) {
    localforage.removeItem(key)
      .then(() => callback && callback(null))
      .catch(err => callback && callback(err))
  },
}

export const clearPersistedState = () =>
  localforage.clear().catch(err => {
    Sentry.captureException(err)
    throw err
  })
